<template>
  <v-container fluid tag="section">
    <validation-observer v-slot="{ invalid }">
      <material-wizard
        v-model="tab"
        :title="title"
        subtitle="Preencha as informações para gerar seu comparativo."
        :available-steps="availableSteps"
        :tabs="tabs"
        class="mx-auto"
        :disabledBtnFinalizar="invalid && tab === tabs.length - 1"
        :loading="loading"
        btnSaveCustomId="btn-save-comparativo"
        @click:next="next(1)"
        @click:prev="tab--"
      >
        <sig-r-wizard-tabs ref="sigRParametros" :items="comparativo" :tucs="tucs" />
      </material-wizard>
    </validation-observer>
  </v-container>
</template>

<script>
  import SigRComparaService from '@/services/SigRComparaService';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      SigRWizardTabs: () => import('@/components/sig-r/SigRWizardTabs'),
      MaterialWizard: () => import('@/components/base/MaterialWizard')
    },

    data() {
      return {
        tab: 0,
        tabs: ['Início', 'Tipo do SIG-R', 'TUCs & ODIs'],
        comparativo: {},
        tucs: [],
        loading: false
      };
    },

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Comparativo' : 'Adicionar Novo Comparativo';
      },

      availableSteps() {
        let steps = [0];

        steps.push(1);
        steps.push(2);
        steps.push(3);

        return steps;
      }
    },

    mounted() {
      if (this.$route.params.id) {
        this.getComparativo(this.$route.params.id);
      }
    },

    methods: {
      next(valid) {
        if (!valid) return;

        if (this.tab === this.tabs.length - 1) {
          this.salvarComparativo();
        } else {
          this.tab++;
        }
      },

      getComparativo(id) {
        SigRComparaService.getComparativo(id)
          .then((response) => {
            this.comparativo = response.data.data;
            this.tucs = JSON.parse(this.comparativo.tucs);
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar comparativo.', '', {
              position: 'topRight'
            });
          });
      },

      salvarComparativo() {
        const data = this.$refs.sigRParametros.exportData();
        const id = !this.$route.params.id ? null : this.$route.params.id;
        this.loading = true;

        SigRComparaService.salvarComparativo(data, id)
          .then(() => {
            this.$toast.success('Comparativo salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.push({
              name: routes.state.appRoutes['SIGR_COMPARA_HISTORICO']
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar comparativo.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>

<style scoped>
  .divisor-picker {
    margin-bottom: 8px;
  }
</style>
